import { render, staticRenderFns } from "./DatasetsView.vue?vue&type=template&id=1fcbef7c&scoped=true"
import script from "./DatasetsView.vue?vue&type=script&lang=js"
export * from "./DatasetsView.vue?vue&type=script&lang=js"
import style0 from "./DatasetsView.vue?vue&type=style&index=0&id=1fcbef7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbef7c",
  null
  
)

export default component.exports